import React from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  Button
} from "@material-ui/core";

const ConfirmDeleteFormModal = props => {
  const deleteUndeleteText = props.modalData.process_form
    ? "delete"
    : "undelete";
  return (
    <Dialog
      modal={false}
      open={props.isDeleteConfirmationOpen}
      onClose={props.onDeleteFormModalClose}
    >
      <DialogTitle
      >{`Confirm ${deleteUndeleteText} form submission`}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to {deleteUndeleteText}{" "}
          <b>{props.modalData.form_name}</b>?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          color="primary"
          keyboardFocused
          onClick={props.onDeleteForm}
        >{`${deleteUndeleteText} form`}</Button>
        <Button color="primary" onClick={props.onDeleteFormModalClose}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ConfirmDeleteFormModal.defaultProps = {};

ConfirmDeleteFormModal.propTypes = {
  modalData: PropTypes.shape({
    process_form: PropTypes.bool,
    form_name: PropTypes.string
  }).isRequired,
  onDeleteFormModalClose: PropTypes.func.isRequired,
  onDeleteForm: PropTypes.func.isRequired,
  isDeleteConfirmationOpen: PropTypes.bool.isRequired
};

export default ConfirmDeleteFormModal;
